(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("RcsbFv3D", [], factory);
	else if(typeof exports === 'object')
		exports["RcsbFv3D"] = factory();
	else
		root["RcsbFv3D"] = factory();
})(self, () => {
return 